import React from 'react';

//TODO: Mergear GenericModal en webcore
import GenericModal from '../../../Packages/SharedComponents/Com.Gyf.WebCore.GenericModal';

import { LinkButton } from 'com-gyf-webcore-userinterfacecomponents';

import HistoryMaxScreen from './HistoryMaxScreen';

const History = (props) => {
    let oHistory = null;
    let EmptyLabel = null;

    if (props.historial.length > 0) {
        oHistory = props.historial.map(function (row) {
            return (
                <li className="list-group-item" key={"History_" + row.id}>
                    <div className="row">
                        <div className="col-xs-12">
                            <p className="inlineListItem">...en </p>
                            <LinkButton onClick={() => props.selectHistorial(row.producto.Id, row.categoria.Id, row.programa.Id)}
                                text={row.producto.Descripcion + " > " + row.categoria.Descripcion + " > " + row.programa.Descripcion} />
                            <span className="ti-close pull-right top-separator-xxs clickable"
                                onClick={() => props.deleteHistorial(row.id)}
                                title="Quitar estos cambios" />
                        </div>
                    </div>
                </li>
            );
        });
    }
    else {
        EmptyLabel =
            <div className="panel-body center">
                <label className="no-margin-bottom">No hay permisos editados</label>
            </div>;
    }

    return (
        <div>
            <div className="panel panel-default edit-permits">
                <div className="panel-heading center">
                    <label className="no-margin-bottom">PERMISOS EDITADOS</label>
                    <span className="ti-list pull-right clickable" onClick={() => {
                        if (props.historial.length > 0) {
                            $("#modal-screen-permissions").modal();
                        }
                    }}></span>
                </div>
                {(EmptyLabel) ? EmptyLabel :
                    <ul className="list-group">
                        {oHistory}
                    </ul>}
            </div>

            {/*MODAL*/}
            <GenericModal id="modal-screen-permissions"
                className="modal fade-out"
                type="ALL_CUSTOM"
                screenSize="modal-dialog modal-generic modal-permissions"
                header={
                    <h2 className="modal-title" id="myModalLabel">
                        <span className="ti-list"></span>Permisos editados
                    </h2>}
                footer={
                    <div className="row">
                        <div className="col-xs-12">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                        </div>
                    </div>}
                body={<HistoryMaxScreen historial={props.historial}
                    deleteHistorial={props.deleteHistorial}
                    selectHistorial={props.selectHistorial} />} />
        </div>
    );
}

export default History;